import moment from "moment";

export const isBefore = (date, target, granularity) => {
  if (date) {
    return moment(date).isBefore(target, granularity);
  }
  return null;
};

export const toMomentObj = date => {
  if (date) {
    return moment(date);
  }
  return null;
};

export const toLocalDateTime = date => {
  if (date) {
    return moment(date).format("YYYY-MM-DD 00:00:00");
  }
  return null;
};

export const toYMDHm = date => {
  if (date) {
    return moment(date).format("YYYY-MM-DD HH:mm");
  }
  return null;
};

export const toYMDHm_jp = date => {
  if (date) {
    return moment(date).format("YYYY年MM月DD日 HH:mm");
  }
  return null;
};

export const timestampToYMDHm_jp = timestamp => {
  if (timestamp) {
    return moment(timestamp, "X").format("YYYY年MM月DD日 HH:mm");
  }
  return null;
};

export const toYMD = (date, format) => {
  if (date) {
    let _format = format === null ? "YYYY-MM-DD" : format;
    return moment(date).format(_format);
  }
  return null;
};

export const calendar_ja = date => {
  if (date) {
    return new Intl.DateTimeFormat("ja-JP-u-ca-japanese", {
      era: "long",
      year: "numeric"
    }).format(date);
  }
  return null;
};

export const toYMD_ja = date => {
  if (date) {
    return moment(date).format("YYYY年MM月DD日");
  }
  return null;
};

export const toDate = string => {
  if (string) {
    return moment(string).toDate();
  }
  return null;
};

export const toEMD_ja = date => {
  if (date) {
    const result = new Intl.DateTimeFormat("ja-JP-u-ca-japanese", {
      era: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    }).format(date);
    return result;
  }
  return null;
};

export const subtractMonthFromToday = months => {
  if (months) {
    return moment().subtract(months, "months");
  }
  return null;
};

export const diffDays = targetDate => {
  if (targetDate) {
    return moment().diff(targetDate, "days");
  }
  return null;
};

export const diffHoursToFrom = (to, from) => {
  return from.diff(to, "hours");
};

export const toHmsFromSec = t => {
  let hms = "";
  let h = (t / 3600) | 0;
  let m = ((t % 3600) / 60) | 0;
  let s = t % 60;

  if (h != 0) {
    hms = h + "時間" + padZero(m) + "分" + padZero(s) + "秒";
  } else if (m != 0) {
    hms = m + "分" + padZero(s) + "秒";
  } else {
    hms = s + "秒";
  }

  return hms;

  function padZero(v) {
    if (v < 10) {
      return "0" + v;
    } else {
      return v;
    }
  }
};

export const elapsedTimeByTimestamp = timestamp => {
  return elapsedTime(moment(Math.floor(timestamp / 1000), "X").format());
};

export const elapsedTime = startTime => {
  let x = new Date(startTime);
  let now = new Date();
  let timeDiff = now - x;
  timeDiff /= 1000;

  let seconds = Math.round(timeDiff);
  timeDiff = Math.floor(timeDiff / 60);

  let minutes = Math.round(timeDiff % 60);
  timeDiff = Math.floor(timeDiff / 60);

  let hours = Math.round(timeDiff % 24);
  timeDiff = Math.floor(timeDiff / 24);

  let days = Math.round(timeDiff % 365);
  timeDiff = Math.floor(timeDiff / 365);

  let years = timeDiff;

  if (years > 0) {
    return years + (years > 1 ? "年" : "年") + "前";
  } else if (days > 0) {
    return days + (days > 1 ? "日" : "日") + "前";
  } else if (hours > 0) {
    return hours + (hours > 1 ? "時間" : "時間") + "前";
  } else if (minutes > 0) {
    return minutes + (minutes > 1 ? "分" : "分") + "前";
  } else if (seconds > 0) {
    return seconds + (seconds > 1 ? "秒" : "秒") + "前";
  } else {
    return "たった今";
  }
};

export default {
  toMomentObj,
  toLocalDateTime,
  toYMDHm,
  toYMDHm_jp,
  timestampToYMDHm_jp,
  toYMD,
  toYMD_ja,
  toDate,
  toEMD_ja,
  subtractMonthFromToday,
  diffDays,
  diffHoursToFrom,
  toHmsFromSec,
  elapsedTime,
  elapsedTimeByTimestamp,
  calendar_ja,
  isBefore
};
